import React from 'react';
import { Button } from "@heroui/react";

export interface ISelectionApplyProps {
    discardChanges: () => void;
    displayOutput: () => void;
}

const SelectionApply: React.FC<ISelectionApplyProps> = ({ discardChanges, displayOutput }) => {
    return (
        <>
            <Button size="sm" className="bg-msi-chart-orange text-white rounded" onPress={discardChanges}>
                Discard
            </Button>
            <Button size="sm" className="bg-msi-darkblue-color text-white rounded" onPress={displayOutput}>
                Apply
            </Button>
        </>
    );
};

export default SelectionApply;